/**
 * MYDORITECH official brand logo (full version with black backing).
 * The asset has the brand wordmark filling the frame, so no crop trick needed.
 *
 * On light backgrounds, the logo's own black backing becomes a strong
 * brand card — fully on-brand per the official brand book.
 */
const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_mydori-ecom/artifacts/sy6nzl66_MYDORITECH%20%281%29.png";

const HEIGHTS = {
  sm: "h-10",
  md: "h-12",
  lg: "h-[50px]",
  xl: "h-28 sm:h-36",
};

export default function Logo({ size = "md", className = "" }) {
  const h = HEIGHTS[size] || HEIGHTS.md;
  return (
    <div className={`inline-flex items-center ${className}`} data-testid="brand-logo">
      <img
        src={LOGO_URL}
        alt="MYDORITECH"
        draggable={false}
        className={`${h} w-auto object-contain block select-none`}
      />
    </div>
  );
}
